import React from "react";

export const Arrow = ({ rotate = 0 }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <path
        d="M13 17L6.14064 10.3298C5.95312 10.1477 5.95312 9.85225 6.14064 9.67022L13 3"
        stroke="#030C23"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
